import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CommunicateService {
  // private host: string = 'localhost';
  private host: string = 'ec2-13-125-216-210.ap-northeast-2.compute.amazonaws.com';
  private port: string = '3000';

  constructor(private httpc: HttpClient) {}
  private get address(): string {
    return `http://${this.host}:${this.port}`;
  }

  public httpPost(url: string, params: any): Promise<any> {
    return this.desktopPost(url, params);
  }

  public httpGet(url: string): Promise<any> {
    return this.desktopGet(url);
  }

  private desktopPost(url: string, params: any): Promise<any> {
    const body = JSON.stringify(params);
    const headers = { 'content-type': 'application/json' };

    return new Promise((resolve, reject) => {
      this.httpc
        .post(`${this.address}/${url}`, body, {
          headers: headers,
        })
        .subscribe(
          data => {
            resolve(data);
          },
          error => {
            reject(error);
          }
        );
    });
  }

  private desktopGet(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpc.get(`${this.address}/${url}`).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}
